import { Box, Button, Typography } from "@mui/material";
import { Controller } from "react-hook-form";

interface Props {
  name: string;
  control: any;
  label: string;
  accept: string;
  error?: string;
  disabled?: boolean;
}

export default function FileUploadField({
  name,
  control,
  label,
  accept,
  error,
  disabled,
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const file: File | null = field.value ?? null;

        return (
          <Box>
            <Typography variant="body2">
              {label}
            </Typography>

            <input
              type="file"
              accept={accept}
              hidden
              id={name}
              onChange={(e) => {
                const f = e.target.files?.[0] ?? null;
                field.onChange(f);
              }}
            />

            <label htmlFor={name}>
              <Button variant="outlined" component="span" disabled={disabled}>
                Choose File
              </Button>
            </label>

            {file && (
              <Typography variant="caption" sx={{ display: 'block', marginTop: 1 }}>
                📎 {file.name} ({(file.size / 1024).toFixed(1)} KB)
              </Typography>
            )}

            {error && (
              <Typography color="error" variant="caption">
                {error}
              </Typography>
            )}
          </Box>
        );
      }}
    />
  );
}